import React from "react";
import { useTranslation } from "react-i18next";
import DefaultActionButtonGenerator from "../../../../components/action-buttons/ActionButtonGenerator";
import ListComponent from "../../../../components/list/ListComponent";
import {formatDate, formatShortDate} from "../../../../utils";

export default function DocumentHistory(props) {
    const {t} = useTranslation(); 

    return (
        <div className="row">

            <div className="col-md-12">
                <ListComponent
                    entityName=""
                    hideSelection={true}
                    endpoint="yonlendirilecek-talep/gecmis-listele"
                    keyField="id"
                    customBody={{
                        id: props.selectedRow.id,
                    }}
                    columns={[
                        {
                            dataField: "islem.name",
                            text: t("tabs.islemTipi"),
                            sort: true,
                        },
                        {
                            dataField: "cdate",
                            text: t("tabs.tarihSaat"),
                            formatter: formatDate,
                            sort: true,
                        },
                        {
                            dataField: "user.fullName",
                            text: t("tabs.ilgiliKisi"),
                            sort: true,
                        },
                    ]}
                    actionButtonsObject={{
                        actions: [],
                        generator: DefaultActionButtonGenerator,
                    }}
                />
            </div>
        </div>
    );
}
